import { render } from "./CourseUserCard.vue?vue&type=template&id=0fe98802&scoped=true"
import script from "./CourseUserCard.vue?vue&type=script&lang=js"
export * from "./CourseUserCard.vue?vue&type=script&lang=js"

import "./CourseUserCard.vue?vue&type=style&index=0&id=0fe98802&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe98802"]])

export default __exports__